<template>
    <div>
        <!-- <GlobalFooter class="i-copyright" :copyright="copyright" /> -->
        <footer class="ivu-global-footer i-copyright">
             <div class="ivu-global-footer-copyright">
                <!-- Copyright ©  小松（中国）投资有限公司 版权所有 --> 
                {{$t('page.common.copyright')}}
                <a style="color:#808695;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502002841" >
                    <!-- 沪ICP备10215464号-3 -->
                    {{$t('page.common.recordNumber1')}}
                </a>
             </div>
             <div style="padding:5px 0;">
                <a style="color:#808695;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502002841" >
                    <img src="@/assets/images/copyright.png" style="vertical-align: middle;"/>
                    <!-- 沪公网安备 31011502002841号 -->
                    {{$t('page.common.recordNumber2')}}
                </a>
             </div>
        </footer>
        
    </div>
</template>
<script>
	import Setting from '@/setting';
    export default {
        name: 'i-copyright',
        data () {
            return {
                copyright: 'Copyright © ' + ' 小松（中国）投资有限公司 版权所有'
            }//new Date().getFullYear() +
        }
    }
</script>
<style lang="less">
    .i-copyright{
        flex: 0 0 auto;
         &-hidden{
            display: none;
        }
    }
    .ivu-global-footer {
	    margin: -10px 0 10px 0 !important;
	    padding: 0 16px;
	    text-align: center;
	}
</style>
